export const closestLvzPathsSelector = ({closestLvzPaths}) => closestLvzPaths